import YourReferralAndSavings from "../../components/YourReferralAndSavings"

const YourReferralAndSavingsContainer = ({ setIsLoggedIn, headLess }) => (
  <YourReferralAndSavings setIsLoggedIn={setIsLoggedIn} headLess={headLess} />
);
export default YourReferralAndSavingsContainer;